import React from 'react';
import { ImpersonateUser } from './ImpersonateUser';

const ImpersonateUserPage: React.FC = () => {
  return (
    <div className='row g-5 g-xl-8'>
      <div className='col-xl-12'>
        <ImpersonateUser />
      </div>
    </div>
  );
};

export default ImpersonateUserPage;
